export default __webpack_public_path__ + "static/media/logo.ec0bc524.png";